export async function downloadUrl(url: string, filename: string) {
  const res = await fetch(url)
  const blob = await res.blob()
  downloadBlob(blob, filename)
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')

  a.href = url
  a.download = filename
  a.className = 'absolute opacity-0'

  document.body.appendChild(a)
  a.click()

  a.remove()
  URL.revokeObjectURL(url)
}
